import { render, staticRenderFns } from "./HeaderWhite.vue?vue&type=template&id=06c759d0&"
import script from "./HeaderWhite.vue?vue&type=script&lang=js&"
export * from "./HeaderWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports